import { memo, useCallback, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getMenuGroupId, getMenuGroupItems, getMenuGroupTitle, getMenuSectionId } from "../../utils/familyMenu";
import { buildCatalogPath } from "../../utils/topbarUtils";

const TopbarDesktopMegaMenu = memo(({
  menuStructure,
  isDesktopMenuOpen,
  activeDesktopCollection,
  activeDesktopGroup,
  onCollectionHover,
  onGroupHover,
  onAllProductsNavigation,
  onCatalogNavigation,
  onCancelClose,
  onScheduleClose,
  onSetSelectedCollection,
  onSetSelectedSubcollection,
  onSetDesktopMenuOpen,
}) => {
  const timerRef = useRef(null);

  useEffect(() => {
    const timer = timerRef.current;
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  const resolvedDesktopCollection = menuStructure.some((item) => item.name === activeDesktopCollection)
    ? activeDesktopCollection
    : (menuStructure[0]?.name || "");
  const activeDesktopSection = menuStructure.find((item) => item.name === resolvedDesktopCollection) || menuStructure[0];
  const activeDesktopGroups = Array.isArray(activeDesktopSection?.groups) ? activeDesktopSection.groups : [];
  const resolvedDesktopGroup = activeDesktopGroups.some((group) => getMenuGroupTitle(group) === activeDesktopGroup)
    ? activeDesktopGroup
    : (activeDesktopGroups[0] ? getMenuGroupTitle(activeDesktopGroups[0]) : "");
  const activeDesktopGroupData = activeDesktopGroups.find((group) => getMenuGroupTitle(group) === resolvedDesktopGroup) || activeDesktopGroups[0] || null;
  const activeDesktopGroupItems = activeDesktopGroupData ? getMenuGroupItems(activeDesktopGroupData) : [];

  const handleFamilyClick = useCallback((item) => {
    const hasGroups = Array.isArray(item?.groups) && item.groups.length > 0;
    onSetSelectedCollection(item.name);
    if (!hasGroups) {
      onCatalogNavigation({
        collection: item.name,
        familyId: getMenuSectionId(item),
        closeDesktopMenu: true,
      });
      return;
    }
    onSetSelectedSubcollection(getMenuGroupTitle(item.groups[0]));
    onCancelClose();
    onSetDesktopMenuOpen(true);
  }, [onCatalogNavigation, onCancelClose, onSetDesktopMenuOpen, onSetSelectedCollection, onSetSelectedSubcollection]);

  const handleGroupClick = useCallback((group) => {
    onCatalogNavigation({
      collection: activeDesktopSection.name,
      subcollection: getMenuGroupTitle(group),
      familyId: getMenuGroupId(group),
      closeDesktopMenu: true,
    });
  }, [activeDesktopSection, onCatalogNavigation]);

  if (!isDesktopMenuOpen) return null;

  return (
    <div
      className="landing-container landing-desktop-submenu surface-overlay border-1 surface-border shadow-4"
      onMouseEnter={onCancelClose}
      onMouseLeave={onScheduleClose}
    >
      <div className="landing-desktop-submenu-layout">
        <div className="landing-desktop-menu-column landing-desktop-menu-column--families">
          <button
            type="button"
            className={`landing-desktop-menu-item text-color-secondary`}
            onClick={() => onAllProductsNavigation({ closeDesktopMenu: true })}
          >
            <span>Todos los productos</span>
          </button>
          {menuStructure.map((item) => (
            <button
              key={item.name}
              type="button"
              className={`landing-desktop-menu-item text-color-secondary ${resolvedDesktopCollection === item.name ? "active" : ""}`}
              onClick={() => handleFamilyClick(item)}
              onMouseEnter={() => onCollectionHover(item)}
            >
              <span>{item.name}</span>
              <i className="pi pi-angle-right"></i>
            </button>
          ))}
        </div>
        <div className="landing-desktop-menu-column landing-desktop-menu-column--groups">
          {activeDesktopGroups.map((group) => (
            <button
              key={getMenuGroupTitle(group)}
              type="button"
              className={`landing-desktop-menu-item text-color-secondary ${resolvedDesktopGroup === getMenuGroupTitle(group) ? "active" : ""}`}
              onClick={() => handleGroupClick(group)}
              onMouseEnter={() => onGroupHover(group)}
            >
              <span>{getMenuGroupTitle(group)}</span>
              <i className="pi pi-angle-right"></i>
            </button>
          ))}
        </div>
        <div className="landing-desktop-menu-column landing-desktop-menu-column--subitems">
          {activeDesktopGroupData ? (
            <>
              <Link
                to={buildCatalogPath({
                  collection: activeDesktopSection.name,
                  subcollection: getMenuGroupTitle(activeDesktopGroupData),
                  familyId: getMenuGroupId(activeDesktopGroupData),
                  menuStructure,
                })}
                className="landing-desktop-submenu-title"
                onClick={() => {
                  onSetSelectedCollection(activeDesktopSection.name);
                  onSetSelectedSubcollection(getMenuGroupTitle(activeDesktopGroupData));
                  onSetDesktopMenuOpen(false);
                }}
              >
                {getMenuGroupTitle(activeDesktopGroupData)}
              </Link>
              <div className="landing-desktop-submenu-items">
                {activeDesktopGroupItems.map((subItem) => (
                  <Link
                    key={`${getMenuGroupTitle(activeDesktopGroupData)}-${subItem.name}`}
                    to={buildCatalogPath({
                      collection: activeDesktopSection.name,
                      subcollection: subItem.name,
                      familyId: subItem.id,
                      menuStructure,
                    })}
                    className="landing-desktop-submenu-link"
                    onClick={() => {
                      onSetSelectedCollection(activeDesktopSection.name);
                      onSetSelectedSubcollection(subItem.name);
                      onSetDesktopMenuOpen(false);
                    }}
                  >
                    {subItem.name}
                  </Link>
                ))}
              </div>
            </>
          ) : (
            <div className="landing-desktop-submenu-empty">Sin subcategorías disponibles.</div>
          )}
        </div>
      </div>
    </div>
  );
});

TopbarDesktopMegaMenu.displayName = "TopbarDesktopMegaMenu";

export default TopbarDesktopMegaMenu;
